import { AxiosPromise } from 'axios'
import { AppApiResponseData } from '../types/api'
import http from './http'
import { JSONObject } from '../types/common'

export function getMembersBillableStatus(
	orgId: string,
	year: string
): AxiosPromise<AppApiResponseData> {
	return http({
		method: 'GET',
		url: `p/organization/${orgId}/dashboard/billable?year=${year}`,
	})
}

export function getMembersBillableTypeStatus(
	orgId: string,
	year: string,
	type: string
): AxiosPromise<AppApiResponseData> {
	return http({
		method: 'GET',
		url: `p/organization/${orgId}/dashboard/billable?year=${year}?type=${type}`,
	})
}

export function getMembersEnrollment(
	orgId: string
): AxiosPromise<AppApiResponseData> {
	return http({
		method: 'GET',
		url: `p/organization/${orgId}/dashboard/enrollment`,
	})
}

export function getServicesActivities(
	orgId: string,
	year: string,
	isChat: boolean,
	isArticles: boolean,
	isTasks: boolean
): AxiosPromise<AppApiResponseData> {
	return http({
		method: 'GET',
		// eslint-disable-next-line max-len
		url: `p/organization/${orgId}/dashboard/activities?year=${year}&chat=${isChat}&articles=${isArticles}&tasks=${isTasks}`,
	})
}

export function getClinicMembersCount(
	orgId: string
): AxiosPromise<AppApiResponseData> {
	return http({
		method: 'GET',
		url: `p/organization/${orgId}/statistics`,
	})
}

export function getOrganizationDetails(
	orgId: string
): AxiosPromise<AppApiResponseData> {
	return http({
		method: 'GET',
		url: `p/organization/${orgId}`,
	})
}

export function updateOrganizationDetails(
	data: any
): AxiosPromise<AppApiResponseData> {
	return http({
		method: 'PUT',
		url: `p/organization`,
		data,
	})
}

export function getAllUsersForOrganization(
	data: JSONObject
): AxiosPromise<AppApiResponseData> {
	return http({
		method: 'POST',
		url: `p/search/user`,
		data,
	})
}
